import { useEffect, useState } from 'react'

/**
 * window resize를 감지하는 hook
 * @param breakPoint window resize break point
 * @returns isBreak
 */
export function useWindowResize(breakPoint?: number) {
  const [isBreak, setIsBreak] = useState<boolean>(false)

  useEffect(() => {
    const checkResize = () => {
      if (typeof breakPoint === 'number') {
        setIsBreak(window.innerWidth <= breakPoint)
      }
    }

    checkResize()

    window.addEventListener('resize', checkResize)

    return () => {
      window.removeEventListener('resize', checkResize)
    }
  }, [])

  return isBreak
}
